import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import './index.css'
import { router } from './router'
import { ExclamationTriangleIcon } from '@heroicons/react/16/solid'
import Clarity from '@microsoft/clarity'
import * as Sentry from '@sentry/react'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      experimental_prefetchInRender: true,
    },
  },
})
// queryClient.setDefaultOptions({
//   queries: {
//     // gcTime: 60000 / 2
//   },
// })
// queryClient.setQueryDefaults('', {staleTime: })
// Initialize Microsoft Clarity
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta?.env?.VITE_APP_ENV ?? 'sandbox',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0, // Adjust as needed
    replaysSessionSampleRate: 0.1, // Adjust as needed
    replaysOnErrorSampleRate: 1.0, // Adjust as needed
  })
}

if (import.meta.env.VITE_CLARITY_ID) {
  Clarity.init(import.meta.env.VITE_CLARITY_ID)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster
        closeButton
        position="bottom-center"
        icons={{
          error: <ExclamationTriangleIcon />,
        }}
        toastOptions={{
          classNames: {
            // info: 'bg-pink-500',
            success: 'bg-gray-highest text-txt-primary-invers',
            error: 'text-txt-primary-invers bg-red-high',
            cancelButton: 'tw-cancel-button',
            closeButton:
              'absolute right-0 top-[23px] left-auto hover:bg-transparent',
          },
        }}
      />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
)
